import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ICredentials } from '../models/credentials.model';

@Injectable({
  providedIn: 'root',
})
export class RolesAccessGuard implements CanActivate {
  credentials: ICredentials | undefined;
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot) {
    this.credentials = this.authService.getCredentials();
    const roles = route.data['accessibleFor'] as Array<string>;
    for (const r of roles) {
      if (this.credentials && this.credentials.role === r) {
        return true;
      }
    }

    this.router.navigate(['/']);
    return false;
  }
}
